import { render, staticRenderFns } from "./veStuAssocMemberShow.vue?vue&type=template&id=4a94067e&scoped=true"
import script from "./veStuAssocMemberShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocMemberShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94067e",
  null
  
)

export default component.exports